import React from 'react';
import styled from '@emotion/styled/macro';
import { SquareAtomProps } from './square.types';

const SquareAtom: React.FC<SquareAtomProps> = ({ colour, className }) => {
  if (colour) {
    return <div className={className} />;
  } else {
    console.warn(`square atom called with falsy prop. data: ${colour}`);
    return null;
  }
};

const StyledSquareAtom = styled(SquareAtom)`
  width: 1.6rem;
  height: 1.6rem;
  margin: 0.5rem;
  ${({ colour }) => (colour ? `background: ${colour}` : null)};
`;

export default StyledSquareAtom;
